import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import gql from 'graphql-tag';
import { Button, Grid, Header } from 'semantic-ui-react';
import { AuthClient, getProfileAvatar, log } from '@emyw/core-lib';
import '../primitives.css';
const deleteProfileMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation ($profileId: Int!) {\n        deleteProfile(profileId: $profileId) {\n            ok\n            errors {\n                path\n                message\n            }\n        }\n    }  \n"])));
export default class DeleteProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false
    };
    this.handleDelete = this.handleDelete.bind(this);
  }
  async handleDelete() {
    this.setState({
      isSubmitting: true
    });
    const {
      profile,
      onClose
    } = this.props;
    try {
      const response = await AuthClient.mutate({
        mutation: deleteProfileMutation,
        variables: {
          profileId: profile.id
        }
      });
      const {
        ok,
        errors
      } = response.data.deleteProfile;
      if (ok) {
        onClose(true, profile.id);
      } else {
        this.setState({
          isSubmitting: false
        });
        log.trace('Error deleting profile:', errors);
      }
    } catch (error) {
      this.setState({
        isSubmitting: false
      });
    }
  }
  render() {
    const {
      profile,
      onClose
    } = this.props;
    const {
      isSubmitting
    } = this.state;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "manageProfiles"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fixedRow middle spaced",
      style: {
        marginBottom: '1em'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "fixedCol middle",
      style: {
        width: '160px',
        margin: '4px 0'
      }
    }, getProfileAvatar({
      profile,
      iconSize: 'huge'
    }), /*#__PURE__*/React.createElement("div", {
      className: "profile_avatar_name"
    }, profile.name)), /*#__PURE__*/React.createElement("div", {
      className: "fixedCol",
      style: {
        margin: '4px 0',
        maxWidth: '55%'
      }
    }, /*#__PURE__*/React.createElement(Header, {
      style: {
        marginBottom: '1em'
      }
    }, "Are you sure you want to delete this profile?")))), /*#__PURE__*/React.createElement(Grid, {
      columns: 2
    }, /*#__PURE__*/React.createElement(Grid.Row, {
      textAlign: "center",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(Grid.Column, {
      width: "8"
    }, /*#__PURE__*/React.createElement(Button, {
      type: "button",
      disabled: isSubmitting,
      onClick: () => onClose(false),
      basic: true,
      color: "grey",
      fluid: true
    }, "Cancel")), /*#__PURE__*/React.createElement(Grid.Column, {
      width: "8"
    }, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: isSubmitting,
      onClick: this.handleDelete,
      basic: true,
      color: "red",
      fluid: true
    }, "Delete")))));
  }
}
DeleteProfile.defaultProps = {
  onClose: () => null
};